module.exports = __webpack_public_path__ + "img/后端开发.3e5f99ae.svg";